module.exports = __webpack_public_path__ + "img/logo6_med.original_v01.592d3e12.png";